import { Pipe, PipeTransform } from '@angular/core';
import { UsuariosService } from '../servicios/usuarios.service';

@Pipe({
  name: 'speed'
})
export class SpeedPipe implements PipeTransform {
  transform(value:any): any {
    if( value !== null ){
      let speed = Math.floor(3.6 * value);
      return speed;
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/speed.pipe.ts